import moment from 'moment';
import sortBy from 'lodash/sortBy';

import { DATE_FORMAT } from '../constants/dateTimeFormats';
import { BUDGET_CHOICES } from '../constants/config';

export const getMoveInChoices = date => {
    const momentObj = moment(date, DATE_FORMAT);

    const result = [];
    for (let i = 0; i < 4; i++) {
        if (momentObj.date() < 15) {
            momentObj.date(15);
        } else {
            momentObj.add(1, 'months').date(1);
        }

        result.push({
            label: momentObj.format('MMMM Do'),
            value: momentObj.format(DATE_FORMAT),
        });
    }

    return result;
};

export const getBudgetChoices = budgetVal => {
    const parsedBudgetVal = parseInt(budgetVal);
    const hasValue = BUDGET_CHOICES.some(item => parsedBudgetVal == parseInt(item.value));
    if (hasValue || !parsedBudgetVal) {
        return BUDGET_CHOICES;
    }

    const newChoices = BUDGET_CHOICES.concat([{ value: parsedBudgetVal, label: `$${parsedBudgetVal}` }]);
    return sortBy(newChoices, 'value');
};

export const parseAmenityValues = amenities => {
    const values = {};
    amenities.forEach(amenity => {
        const amenityArr = amenity.split(':');
        const amenityName = amenityArr[0];
        const amenityValue = JSON.parse(amenityArr[1]);
        const amenityType = amenityArr[2];

        if (amenityType == 'arr') {
            if (!values[amenityName]) {
                values[amenityName] = [];
            }
            values[amenityName].push(amenityValue);
        } else {
            values[amenityName] = amenityValue;
        }
    });

    return values;
};
